var mk = require('./dist/js/core');

module.exports = mk;